export default __webpack_public_path__ + "static/media/14.04f21903.jpg";